import React from 'react';

interface IOwnProps {
    url?: string;
}

type Props = IOwnProps;

class TagsItem extends React.Component<Props, {}> {
    public render() {
        if (!this.props.children) {
            return null;
        }

        return <li className="tags__list__item">
            {this.props.url ? this.renderItemLink : this.renderItemBlock}
        </li>
    }

    private get renderItemLink() {
        const isExternal = this.props.url!.startsWith('http');

        return <a href={this.props.url} className="button button--tag" target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined}>
            {this.props.children}
        </a>;
    }

    private get renderItemBlock() {
        return <div className="button button--tag button--tag--inactive">
            {this.props.children}
        </div>;
    }
}

export default TagsItem;